export enum ShopCategory {
  Pharmacy = 'Pharmacy',
  Mobile = 'Mobile',
  Electronics = 'Electronics',
  Grocery = 'Grocery',
  Stationery = 'Stationery',
  Cosmetics = 'Cosmetics',
  Fashion = 'Fashion',
  HomeAppliances = 'HomeAppliances',
  Toys = 'Toys',
  Books = 'Books',
}

export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

// Base interface for shop details common in many types
interface BaseShop {
  name: string;
  slug: string;
  city?: string;
  state?: string;
  country?: string;
  streetAddress?: string;
  contactNumber?: string;
  shopCategory?: ShopCategory;
}

export interface CreateShopFormValues extends BaseShop {}

export interface ShopListItem extends BaseShop {
  id: string;
  country: string; // making sure it's required here
  state: string; // required here
  city: string; // required here
  streetAddress: string; // required here
  contactNumber: string; // required here
  logoUrl: string | null;
  coverImageUrl: string | null;
  createdByUserName: string;
  category: ShopCategory; // NOTE: different name than shopCategory? Keep both or unify?
  isActive: boolean;
}

// Social profile related to shop
export interface ShopSocialProfile {
  id: string;
  shopId?: string;
  platform: string;
  url: string;
}

// Business hour for a shop
export interface ShopBusinessHour {
  id: number;
  shopId: string;
  day: DayOfWeek;
  openTime: string;
  closeTime: string;
  isClosed: boolean;
}

export interface ShopFormValues extends CreateShopFormValues {
  description?: string;
  logoUrl?: string;
  coverImageUrl?: string;
  notificationEmail?: string | null;
  enableNotification: boolean;
  zipCode?: string;
  metaDescription?: string;
  metaKeywords?: string;
  isActive: boolean;
  socialProfiles: ShopSocialProfile[];
  businessHours: ShopBusinessHour[];
}
